module.exports = __webpack_public_path__ + "img/LTS_CIMA.978add78.gif";